import _isNil from 'lodash/isNil';
import { useEffect, useState } from 'react';

const useMapboxRouteAnimation = (
	isPlaying,
	routeIndex,
	routeFeature,
	onRouteIndexChange,
	onUpdateProfileImagePoint,
	stopAnimation
) => {
	const isRouteIndexValid = routeIndex => routeIndex < routeFeature.geometry.coordinates.length - 1;

	const [lastRunTimestamp, setLastRunTimestamp] = useState<number>();
	const routeLength = routeFeature.geometry.coordinates.length;

	useEffect(() => {
		if (!isPlaying) {
			setLastRunTimestamp(undefined);
			return;
		}
		let animationFrameId: number;
		// Request the next frame of animation as long as the end has not been reached
		if (isRouteIndexValid(routeIndex)) {
			if (!lastRunTimestamp) {
				setLastRunTimestamp(performance.now());
				animationFrameId = requestAnimationFrame(animateRouteTrackerIfNeeded);
				return;
			}
			const elapsed = performance.now() - lastRunTimestamp;
			const relativeRouteIndex = Math.round((routeIndex + elapsed * 0.01) % routeLength);
			setLastRunTimestamp(performance.now());

			if (relativeRouteIndex !== routeIndex) {
				onRouteIndexChange(relativeRouteIndex);
			} else {
				animationFrameId = requestAnimationFrame(animateRouteTrackerIfNeeded);
			}
		}
		return () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
		};
	}, [routeIndex]);

	const animateRouteTrackerIfNeeded = () => {
		if (!shouldAnimateRouteTracker()) {
			stopAnimation();
			return;
		}
		animateRouteTracker();
	};

	const animateRouteTracker = () => {
		onUpdateProfileImagePoint();

		if (isRouteIndexValid(routeIndex)) {
			onRouteIndexChange(routeIndex + 1);
		}
	};

	const shouldAnimateRouteTracker = () => {
		return !_isNil(routeFeature.geometry.coordinates[routeIndex]);
	};

	return { animateRouteTrackerIfNeeded, isRouteIndexValid };
};

export default useMapboxRouteAnimation;
